/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Infos'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeInfosLuggage from '../../../components/infos/luggage/Home.vue'; // lugagge
import HomeInfosCovid19 from '../../../components/infos/covid19/Home.vue'; // covid
import HomeInfosDangerousGoods from '../../../components/infos/dangerous-goods/Home.vue'; // dangerous-goods
import HomeInfosProhibitedItems from '../../../components/infos/prohibited-items/Home.vue'; // prohibited-items
import HomeInfosAdditionalServices from '../../../components/infos/additional-services/Home.vue'; // additional-services
import HomeInfosServiceOnBoard from '../../../components/infos/serviceonboard/Home.vue'; // serviceonboard
import HomeInfosSeatReservation from '../../../components/infos/seat-reservation/Home.vue'; // seat-reservation
import HomeInfosFareConditions from '../../../components/infos/fare-conditions/Home.vue'; // fare-conditions
import HomeInfosComplaints from '../../../components/infos/complaints/Home.vue'; // complaints
import HomeInfosGroupBooking from '../../../components/infos/group-booking/Home.vue'; // group-booking
import HomeInfosInfoAlertBooking from '../../../components/infos/infoalert/Home.vue'; // infoalert (Ticket:APP)

export const routesinfos = [
    { path: '/luggage', component: HomeInfosLuggage },
    { path: '/covid19', component: HomeInfosCovid19 },
    { path: '/dangerous-goods', component: HomeInfosDangerousGoods },
    { path: '/prohibited-items', component: HomeInfosProhibitedItems },
    { path: '/additional-services', component: HomeInfosAdditionalServices },
    { path: '/serviceonboard', component: HomeInfosServiceOnBoard },
    { path: '/seat-reservation', component: HomeInfosSeatReservation },
    { path: '/fare-conditions', component: HomeInfosFareConditions },
    { path: '/complaints', component: HomeInfosComplaints },
    { path: '/group-booking', component: HomeInfosGroupBooking },
    { path: '/infoalert', component: HomeInfosInfoAlertBooking },
];
